export const enum AuthEndpoint {
  Token = '/auth/token'
}

export const ssoAuthRedirectUrl = `/?redirectTo=${window.location.origin}/auth`;
